import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getAccountMatchContextConfiguration({
  firstName, lastName, dob, email, captchaToken, rootId,
}) {
  return new NetworkRequestConfiguration({
    endpoint: 'contexts/account_match_context',
    method: NetworkRequestConfiguration.Methods.GET,
    queryParameters: {
      first_name: firstName,
      last_name: lastName,
      dob,
      email,
      captchaToken,
      rootId,
    },
    errorCodes: [204, 500],
  });
}
